import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";
import TreeViewSelectProvider from "../../components/TreeView/TreeViewSelectProvider";
import { useAuthentication } from "../../reducer/authentication";
import { useViewMode } from "../../reducer/viewMode";
import Authenticated from "../Authenticated";
import SystemMobile from "../SystemMobile";
import UpdateChecker from "../UpdateChecker";
import SystemRoot from "./SystemRoot";

function System() {
    const viewMode = useViewMode();
    const { user } = useAuthentication();
    return (
        <Authenticated>
            <TreeViewSelectProvider>
                <UpdateChecker />
                <BreadcrumbsProvider>
                    {viewMode === 'mobile' && user?.perm_task ? <SystemMobile /> : <SystemRoot />}
                </BreadcrumbsProvider>
            </TreeViewSelectProvider>
        </Authenticated>
    );

}

export default System;